import intlTelInput from 'intl-tel-input';
import IntlCountries from './IntlCountries';
import { differenceInMinutes, isFuture, isPast} from 'date-fns';
import { utcToZonedTime, format as formatDate } from 'date-fns-tz';




export function baseUrl() {
	return window.doctori.schemeAndHttpHost;
}





/**
 * Get all localization messages
 *
 * @return {object}
 */
export function allMessages() {

	return window.doctori.messages;
}




/**
 * Get key message
 *
 * @return {string}
 */
export function trans(key) {

    return getProperty(window.doctori.messages, key);
}




/**
 * Validation Language Lines
 *
 * @return {object}
 */
export function allValidations() {

	return window.doctori.validation;
}




/**
 * Get website locale
 *
 * @return {string} ar|fr
 */
export function locale() {

	return window.doctori.locale;
}




/**
 * Check if current display website
 * language is frensh
 *
 * @return {Boolean}
 */
export function isFr() {

	return locale() === 'fr';
}




/**
 * Depend on the current display website language,
 * return the proper comma
 *
 * @return {string}
 */
export function comma() {

    return isFr() ? ', ' : '، ';
}




/**
 * Doctor latitude
 *
 * @return {number}
 */
export function doctorLat() {

	return window.doctori.practitioner.lat;
}




/**
 * Doctor langtitude
 *
 * @return {number}
 */
export function doctorLng() {

	return window.doctori.practitioner.lng;
}




/**
 * Doctor full address
 *
 * @return {string}
 */
export function doctorFullAddress() {

	return  window.doctori.practitioner.address + comma() +
			window.doctori.practitioner.postal_code + comma() +
			window.doctori.practitioner.ville
}




/**
 * Check if current doctor is a subscriber
 *
 * @return {Boolean}
 */
export function isSubscribed() {
	return !!window.doctori.practitioner.subscribed_at;
}




/**
 * Doctor speciality id
 *
 * @return {number}
 */
export function doctorSpecialityId() {

	return window.doctori.practitioner.speciality_id;
}




/**
 * Get asset url
 *
 * @param  {string} path
 * @return {string}
 */
export function asset(path) {

	return window.doctori.cdn_url.replace('placeholder', path);
}




/**
 * Get route by name
 *
 * @param  {String} routeName
 * @return {String}
 */
export function route(routeName) {

    return routes(routeName);
}




/**
 * Get all routes or one by name
 *
 * @param  {(String|null)} routeName
 * @return {(String|Object)}
 */
export function routes(routeName = null) {

    var routes = window.doctori.paths;

    return routeName ? getProperty(routes, routeName) : routes;
}




/**
 * Replace multiple strings with multiple other strings
 *
 * @see https://stackoverflow.com/a/15604206/4325011
 *
 * @param  {string} str
 * @param  {Object} mapObj
 * @return {string}
 */
export function replaceAll(str, mapObj = {}) {

    var regex = new RegExp(Object.keys(mapObj).join("|"),"gi");

    return str.replace(regex, function(matched) {

        return mapObj[matched.toLowerCase()];
    });
}




/**
 * Redirect to a given url
 *
 * @param  {string} url
 * @return {void}
 */
export function redirect(url) {

	// similar behavior as clicking on a link
	window.location.href = url;
}




/**
 * Reload the page
 *
 * @return {void}
 */
export function reload() {

    return redirect(document.URL);
}




/**
 * Check if browser under tablet width
 *
 * @param  {Number}  size
 * @return {Boolean}
 */
export function isTabletSize(size = 991) {

	return matchMedia(`(max-width: ${size}px)`).matches;
}

/**
 * Check if browser is under mobile width
 *
 * @param  {Number}  size
 * @return {Boolean}
 */
export function isMobileSize(size = 480) {
    return matchMedia(`(max-width: ${size}px)`).matches;
}

/**
 * Check if browser is in desktop size
 *
 * @param  {Number}  size
 * @return {Boolean}
 */
export function isDesktopSize(size = 991) {

    return matchMedia(`(min-width: ${size}px)`).matches;
}




/**
 * Format date to Y-m-d
 *
 * @param  {Date}   date
 * @param  {String} separator
 * @return {String}
 */
export function ymd(date = new Date(), separator = '-') {

	return date.getFullYear() + separator + ("0" + (date.getMonth() + 1)).slice(-2) + separator + ("0" + date.getDate()).slice(-2);
}




/**
 * Check if the given email is valid
 *
 * @param  {string}  email
 * @return {Boolean}
 */
export function isValidEmail(email) {

	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}




export function initIntlInput(input) {

	var countryData = intlTelInputGlobals.getCountryData();

	$.each(countryData, function(i, country) {
		country.name = IntlCountries[country.iso2];
	});

	return intlTelInput(input, {
		initialCountry: "",
		preferredCountries: ['ma', 'fr'],
		// geoIpLookup: function(callback) {
		// 	$.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
		// 		var countryCode = (resp && resp.country) ? resp.country : "";
		// 		callback(countryCode);
		// 	});
		// },
		utilsScript: require('@public/js/utils')
	});
}



/**
 * Get keys
 *
 * @return {string}
 */
export function keys(key = null) {

    return key ? window.doctori.keys[key] : window.doctori.keys;
}




/**
 * Access object child properties using a dot notation string
 *
 * @see https://stackoverflow.com/a/8052100/4325011
 *
 * @param  {object} object
 * @param  {string} property
 * @return {string}
 */
export function getProperty(object, property) {

    var array = property.split(".");

    while(array.length && (object = object[array.shift()]));

    return object;
}




/**
 * Simple template engine
 *
 * @see https://github.com/krasimir/absurd/blob/master/lib/processors/html/helpers/TemplateEngine.js
 * @param {string} html
 * @param {object} options
 */
export function templateEngine(html, options) {

    var re = /<%(.+?)%>/g,
        reExp = /(^( )?(var|if|for|else|switch|case|break|{|}|;))(.*)?/g,
        code = 'with(obj) { var r=[];\n',
        cursor = 0,
        result,
            match;
    var add = function(line, js) {
        js? (code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n') :
            (code += line != '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '');
        return add;
    }
    while(match = re.exec(html)) {
        add(html.slice(cursor, match.index))(match[1], true);
        cursor = match.index + match[0].length;
    }
    add(html.substr(cursor, html.length - cursor));
    code = (code + 'return r.join(""); }').replace(/[\r\t\n]/g, ' ');
    try { result = new Function('obj', code).apply(options, [options]); }
    catch(err) { console.error("'" + err.message + "'", " in \n\nCode:\n", code, "\n"); }
    return result;
};




/**
 * Get tokbox data
 *
 * @param  {string} [key]
 * @return {(string|object)}
 */
export function tokbox(key = null) {

    var data = window.doctori.tokbox;

    return key ? getProperty(data, key) : data;
}



/**
 * Get appointment time info
 *
 * @param  {date} startAt
 * @param  {date} endAt
 * @return {array}
 */
export function appointmentTimeInfo(startAt, endAt, dateNow = null) {

    var now               = dateNow ? dateNow : zonedNow();
    var startAt           = new Date(startAt);
    var endAt             = new Date(endAt);


    var sessionLength     = differenceInMinutes(
        endAt /* the later date */,
        startAt /* the earlier date */
    );

    // if startAt is in the future, so startAt is the later date, and "now" is the earlier date
    var remainingMinutes  = isFuture(startAt) ? differenceInMinutes(startAt, now) : 0;

    // if startAt is in the past, so startAt is the earlier date and "now" is the later date
    var elapsedMinutes    = isPast(startAt) ? differenceInMinutes(now, startAt) : 0;

    // when do we consider a session as expired
    // when there's 10 minutes delay, wich means
    // the elapsed minutes since the appointment start
    // is more than session length + 10 minutes
    var sessionExpired    = elapsedMinutes > sessionLength + 10;
    var sessionNotExpired = ! sessionExpired;

    // we can make it to the appointment as long as we are in safe time.
    var inOvertime        = (elapsedMinutes - sessionLength) <= 10;

    var active            = remainingMinutes <= 10 && sessionNotExpired;
    var inactive          = remainingMinutes > 10;

    return {
        sessionLength,
        remainingMinutes,
        elapsedMinutes,
        sessionExpired,
        inOvertime,
        active,
        inactive
    };
}


/**
 * Convert now to a zoned now
 *
 * @param  {String} timezone
 * @return {Date}
 */
export function zonedNow(timezone = 'UTC') {

    return toZonedDate(new Date());
}


/**
 * Convert now to a zoned now string
 *
 * @param  {String} format
 * @param  {String} timezone
 * @return {String}
 */
export function zonedNowString(format = 'yyyy-MM-dd HH:mm:ss', timezone = 'UTC') {

    return toZonedDateString(new Date(), format, timezone);
}


/**
 * Convert a date to specific timezone date
 *
 * for format please
 * @see https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param  {(Date|String)} date
 * @param  {String} timezone
 * @param  {String} format
 * @return {(Date|Null)}
 */
export function toZonedDate(date, timezone = 'UTC') {

    if (! (date instanceof Date)) { // i'ts (maybe) a string
        date = new Date(date);
    }

    // check if it's valid Date
    if (isNaN(date)) {
        return null;
    }

    return utcToZonedTime(date, timezone);
}


/**
 * Convert date to string in the given timezone
 *
 * for format please
 * @see https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param  {(Date|String)} date
 * @param  {String} format
 * @param  {String} timezone
 * @return {String}
 */
export function toZonedDateString(date, format = 'yyyy-MM-dd HH:mm:ss', timezone = 'UTC')
{
    const zonedDate = toZonedDate(date, timezone);

    return zonedDate ? formatDate(zonedDate, format, { timezone }) : null;
}


/**
 * Is the given zonedDate in the zoned future?
 *
 * @todo tests
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 */
export function isZonedFuture(zonedDate) {

    return zonedDate.getTime() > zonedNow();
}

/**
 * Is the given zonedDate in the zoned past?
 *
 * @todo tests
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 */
export function isZonedPast(zonedDate) {

  return zonedDate.getTime() < zonedNow();
}

/**
 * Get server current date
 *
 * @param  {(Object|null)} callbacks
 * @return {Object} Date
 */
export function getDate(callbacks = null) {

    var currentTime = getCurrentTime(callbacks);

    return new Date(currentTime.date);
}

/**
 * Get server current time
 *
 * @return {Object}
 */
export function getCurrentTime(callbacks = null) {

    // those callbacks do not work, maybe it's because this is synchronos !!!
    callbacks            = callbacks || {};
    callbacks.beforeSend = callbacks.hasOwnProperty('beforeSend') ? callbacks.beforeSend : function() {};
    callbacks.done       = callbacks.hasOwnProperty('done') ? callbacks.done : function(reponse) {};
    callbacks.always     = callbacks.hasOwnProperty('always') ? callbacks.always : function() {};

    var currentTime;

    $.ajax({
        url: route('siteApiCurrentTime'),
        type: 'GET',
        async: false,
        cache: false,
        dataType: 'json',
        beforeSend: callbacks.beforeSend()
    })
    .done(function(response) {
        currentTime = response;
        callbacks.done(response);
    })
    .always(function() {
        callbacks.always();
    });

    return currentTime;
}


/**
 * Build URL
 *
 * @param  {String} baseUrl
 * @param  {Object} params
 * @return {String}
 */
export function buildUrl(baseUrl, params = {}) {

    var query = buildUrlQuery(params);

    return query ? baseUrl +'?'+ query : baseUrl;
}


/**
 * Build URL query parameters
 *
 * @param  {Object} params
 * @return {String}
 */
export function buildUrlQuery(params = {}) {

    return Object.entries(params)
                .map(pair => pair.map(encodeURIComponent).join('='))
                .join('&');
}


/**
 * Custom log
 *
 * @param  {String} message
 * @param  {String} color
 * @return {String}
 */
export function customLog(message, color='black') {

    let logType = 'log';

    switch (color) {
        case 'success':
            color = 'Green';
        break;

        case 'info':
            color = 'Blue';
            logType = 'info';
        break;

        case 'error':
            color = 'Red';
            logType = 'error';
        break;

        case 'warning':
            color = 'Orange';
            logType = 'warning';
        break;

        default:
            color = color;
    }

    console[logType](`%c${message}`, `color:${color}`);
}
